module.exports = __webpack_public_path__ + "static/img/pitch_green_wide.5701a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_green_wide.png
// module id = HZhf
// module chunks = 94